import { createApiError } from "../../utilities/apiError";


export interface SignUpStartPayload {
    email: string;
    password?: string;
    firstName: string;
    lastName: string;
    displayName: string;
    timeZone: string;
    continueUrl?: string;
}

export interface SignUpStartResponse {
    ok: boolean;
    message: string;
    email: string;
    verificationEmailSentAt: string;
}

export interface ResendVerificationPayload {
    email: string;
}

export interface ResendVerificationResponse {
    ok: boolean;
    message: string;
    verificationEmailSentAt: string;
}

/**
 * Initiates the sign-up process, creates the Firebase user, and sends a verification email.
 * Auth Required: None (AllowAnonymous)
 */
export async function startSignup(payload: SignUpStartPayload): Promise<SignUpStartResponse> {
    const apiUrl = `${process.env.REACT_APP_API_BASE_URL}/authentication/signup/start`;

    try {
        const response = await fetch(apiUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        });

        if (!response.ok) {
            let errorBody;
            try {
                errorBody = await response.json();
            } catch (e) {
                errorBody = { message: response.statusText };
            }
            throw createApiError({
                status: response.status,
                message: errorBody.message || `API request failed with status ${response.status}`,
                details: errorBody,
            });
        }

        return await response.json();
    } catch (error: any) {
        console.error("Error starting signup:", error);
        throw error;
    }
}

/**
 * Resends the verification email for a user who has started sign up.
 * Auth Required: None (AllowAnonymous)
 */
export async function resendVerificationEmail(payload: ResendVerificationPayload): Promise<ResendVerificationResponse> {
    const apiUrl = `${process.env.REACT_APP_API_BASE_URL}/authentication/signup/resend-verification`;

    try {
        const response = await fetch(apiUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        });

        if (!response.ok) {
            let errorBody;
            try {
                errorBody = await response.json();
            } catch (e) {
                errorBody = { message: response.statusText };
            }
            throw createApiError({
                status: response.status,
                message: errorBody.message || `API request failed with status ${response.status}`,
                details: errorBody,
            });
        }

        return await response.json();
    } catch (error: any) {
        console.error("Error resending verification email:", error);
        throw error;
    }
}